import { render, staticRenderFns } from "./seeReform.vue?vue&type=template&id=574ad3ee"
import script from "./seeReform.vue?vue&type=script&lang=js"
export * from "./seeReform.vue?vue&type=script&lang=js"
import style0 from "./seeReform.vue?vue&type=style&index=0&id=574ad3ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports